wbApp.factory('mainSettingsSvc', ['$resource', 'repositorySvc',
    function ($resource, repositorySvc) {
        var MainSetting = $resource('/Api/MainSettings/:id', {}, {
            'get': { method: 'GET', isArray: false, url: '/Api/MainSettings/Get' },
            'update': { method: 'POST', url: '/Api/MainSettings/Update' },
        });

        function getAsync() {
            return repositorySvc.customGet('get', MainSetting, {});
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                MainSetting,      // $resource
                null,             // collection
                data,             // entity
                successCallback,
                errorCallback);
        }

        return {
            getAsync: getAsync,
            update: update
        }
    }]);